const priceParser = price => (
  parseFloat(price)
    .toLocaleString('en-GB', {style: 'currency', currency: 'GBP'})
    .replace(/,/g, ' ')
)

export default priceParser
